<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('customers.customer_notes.note')"
            :is-required="true"
            :error="errors.note"
        >
            <DFormTextarea
                id="note"
                v-model="form.note"
                rows="5"
                :is-valid="isFormFieldValid('note')"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.customer_notes.is_sticky')"
            :is-required="true"
            :error="errors.isSticky"
        >
            <DFormCheck
                id="is_sticky"
                v-model="form.isSticky"
                inline
                :is-valid="isFormFieldValid('isSticky')"
            />
        </DFormRow>

        <DFormControls
            :cancel-route="$route('customers.customers.customer-notes.index', {customer: customerNote.customerId})"
            :dirty="form.isDirty"
            :show-incident-list="customerNote.id ? false : true"
            :customer-id="customerNote.id ? 0 : customerNote.customerId"
            @setIncident="setIncident"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'NoteForm',
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        customerNote: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['submit'],
    data () {
        return {
            form: this.$inertia.form({
                isSticky: this.customerNote.isSticky ?? false,
                note: this.customerNote.note ?? null,
                incident_id: null
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('submit', this.form)
        },
        setIncident (value) {
            this.form.incident_id = value
        }
    }
}
</script>
